module.exports = __webpack_public_path__ + "75482e6d25859275630c4f7c25afbdf7.png";